// extracted by mini-css-extract-plugin
var _1 = "panel_contentWrapper";
var _2 = "panel_panel";
var _3 = "panel_sig-down-table";
export { _1 as "contentWrapper", _2 as "panel", _3 as "sig-down-table" }
